import { w } from 'windstitch';

export const ParallaxContainer = w.section(
  'relative h-[800px] w-full flex justify-center'
);

export const ParallaxBackground = w.div(
  'absolute left-0 right-0 h-[960px] bg-cover bg-center  bg-fixed');

export const ParallaxImg = w.div(
  'absolute bg-no-repeat bg-contain bg-fixed w-[1200px] h-[960px]  bg-no-repeat bg-fixed'
);

export const ParallaxContent = w.div(
  'relative  text-white z-20 w-[1200px]'
)

export const ParallaxContentBox = w.div(
  'flex h-fit bottom-[250px] absolute  w-[1200px]'
)

export const ParallaxContentH5 = w.h5(
  'font-roboto font-bold text-[32px] leading-[40px] tracking-[1px]'
)

export const ParallaxContentH1 = w.h1(
  'font-roboto font-black text-[64px] leading-[72px] tracking-[2px] text-center capitalize'
)

export const ParallaxContentP = w.p(
  'font-roboto mt-[20px] mb-[50px] font-normal text-[16px] leading-[24px] tracking-[1px] w-[425px]'
)

export const BtnBox = w.div(
  'h-fit bottom-[450px] flex gap-[12px]'
);

export const Btn = w.button(
  'h-10 px-4 py-2 gap-2 rounded-[24px] flex items-center'
);

export const BtnOpportunityBox = w.div(
  'h-full relative flex justify-center items-end'
);

export const BtnOpportunity = w.button(
  ' h-fit flex flex-col items-center gap-2 font-roboto font-bold text-[16px] leading-[24px] tracking-[1px] text-center capitalize'
);